import React, { useState } from 'react';
import { useNavigation } from 'context/NavigationContext';
import {
	BringzzPageContainer,
	BringzzButton,
	BringzzIcon,
	BringzzText,
	BringzzInput
} from '@bringzz/components';
import useUser from 'hooks/useUser';
import useRequest from 'hooks/useRequest';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';

const EditSVNRView = () => {
	const { backPress, navigate } = useNavigation();
	const { sendRequest, loading } = useRequest();
	const { getUser } = useUser();
	const [stateInsuranceId, setStateInsuranceId] = useState('');
	const [isValidInput, setIsValidInput] = useState(false);
	const { t } = useTranslation();
	const { user, refreshUserData } = useAuth();

	return (
		<BringzzPageContainer
			header={{
				left: (
					<BringzzIcon
						size='22'
						icon='IconChevronLeft'
						folder='LineIcons'
						className='cursor-pointer'
						onClick={backPress}
					/>
				),
				title: <BringzzText tag='h2'>{t('component.account.svnr.title')}</BringzzText>
			}}
			footer={
				<div className='pb-28 px-6'>
					<BringzzButton
						size='lg'
						className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
						onClick={async () => {
							await sendRequest({
								method: 'POST',
								url: `/module/profile/changeSINumber`,
								data: { stateInsuranceId }
							})
								.then(response => {
									if (response.status === 'success') {
										refreshUserData()
										backPress()
									}
								})
								.catch(error => {
									console.log(error);
								});
						}}
						disabled={loading || !stateInsuranceId || !isValidInput}
					>
						{t('common.save')}
					</BringzzButton>
				</div>
			}
		>
			<div className='p-6 space-y-4'>
				<BringzzInput
					onChange={(e, isValid, newValue) => {
						setIsValidInput(isValid);
						setStateInsuranceId(newValue);
					}}
					defaultValue={user.stateInsuranceId}
					id='id'
					label={t('component.account.svnr.label')}
					containerClassname='w-full'
					placeholder={t('component.account.svnr.placeholder')}
					pattern='^[0-9]+$'
					type='text'
				/>
			</div>
		</BringzzPageContainer>
	);
};

export default EditSVNRView;
